// Client V2 common imports
const configureCommonStore = require('client-v2/common/state/store')

function configureStore(options) {
  return configureCommonStore({
    reducer: require('./reducer'),
    reviver: require('./record').reviver,
    ...options
  })
}

module.exports = configureStore
